// import Basket from "./basket";
import UrlFactory from "./urlFactory";

import DateFactory from "./DateFactory";
import KeyboardNavFactory from "./keyboardNavFactory";
import searchBarFactory from "./searchBarFactory";
import searchHistoryFactory from "./searchHistoryFactory";

import SiteTitleFactory from "./siteTitleFactory";
import ActivityFactory from "./ActivityFactory";
import LocationFactory from "./LocationFactory";

const modul = angular

    .module("factories", [])

    .factory("UrlFactory", UrlFactory)

    .factory("keyboardNavFactory", KeyboardNavFactory)
    // Form
    // .service("Basket", Basket)

    .factory("DateFactory", DateFactory)
    .factory("siteTitleFactory", SiteTitleFactory)

    .factory("searchBarFactory", searchBarFactory)
    .factory("LocationFactory", LocationFactory)
    .factory("ActivityFactory", ActivityFactory)
    .factory("searchHistoryFactory", searchHistoryFactory);

export default modul.name;
